




























import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import notificationService from "@/services/notificationService";
import cPopup from "@/components/default/Popup.vue";
import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxGroupItem,
  DxLabel
} from "devextreme-vue/form";

import contactsRepository from "@/services/contactsRepository";
import ordersService from "@/modules/orders/ordersService";

@Component({
  components: {
    cPopup,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel
  }
})
export default class CreateSettlementPopup extends Vue {
  @Prop({ required: true })
  private contracts!: any[];

    saving = false;

    private show: boolean = false;
    private loading: boolean = false;

  private model: IOrderCreateFromMeasuringStatesCommand = {
    selectedMeasuringStates: [],
    projectId: "",
    contractNumber: ""
  };

  public open(input: IOrderCreateFromMeasuringStatesCommand) {
    Object.assign(this.model, input);
    this.show = true;
  }

  async save() {
    try {
      const validationResult = (this.$refs
        .CreateSettlementPopupForm as any).instance.validate();
      if (validationResult.isValid) {
        this.loading = true;

        const result = (await ordersService.createFromMeasuringStates(
          this.model
        )).data;
        this.$router.push({ path: `/orders/${result}` });
        this.show = false;
      } else {
        notificationService.invalidForm();
      }
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loading = false;
    }
  }

  get articles() {
    return this.$store.getters["articles/items"] as IArticle[];
  }

  get contractOptions() {
    const self = this;
    return {
      dataSource: this.contracts,
      valueExpr: "documentNumber",
      displayExpr: (e: any) => {
        if (!e) {
          return "";
        }
        return `${e.documentNumber} - ${e.subcontractorName}`;
      },
      searchExpr: "name",
      searchEnabled: true,
      showClearButton: true
    };
  }

  get fields() {
    return [
      {
        itemType: "simple",
        dataField: "contractNumber",
        editorOptions: this.contractOptions,
        editorType: "dxSelectBox",
        label: {
          text: "Contract"
        },
        validationRules: [{ type: "required", message: "Veld is verplicht" }]
      }
    ];
  }
}
